<template>
  <button :type="type" :class="buttonClasses" @click="handleClick" :disabled="disabled">
    <div v-if="loading" class="flex items-center justify-center">
      <svg class="animate-spin ltr:-ml-1 rtl:-mr-1 ltr:mr-3 rtl:ml-3 h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
        </path>
      </svg>
      <slot></slot>
    </div>
    <slot v-else></slot>

  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    mode: {
      type: String,
      default: "primary", // Default to 'primary' if not provided
    },
    size: {
      type: String,
      default: "medium", // Default to 'medium' size if not provided
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button", // Default to 'button' if not provided
    },
    customClasses: String,
    loading: {
      type: Boolean, // Default to false if not provided
      default: false
    }
  },
  computed: {
    /**
     * Return all the classes combined to be attached to button
     */
    buttonClasses() {
      // Base button class (e.g., padding, border-radius)
      let baseClasses = "w-full font-bold rounded-md text-center focus:outline-none whitespace-nowrap";

      // Type-based classes
      let modeClasses = {
        primary: "bg-blue text-white hover:bg-blue-600 focus:ring-blue-300",
        "primary-outlined": "text-blue bg-white hover:bg-[#2B63E326] border border-blue border-solid",
        "primary-rounded-outlined": "rounded-xl text-blue bg-white hover:bg-[#2B63E326] border border-blue border-solid",
        "primary-white": "bg-white text-gray-900 hover:bg-blue hover:text-white focus:ring-blue",
        secondary: "bg-green text-white",
        "secondary-outlined": "text-green bg-white hover:bg-[#20B38126] border border-green border-solid",
        "secondary-rounded-outlined": "rounded-xl text-green bg-white hover:bg-[#20B38126] border border-green border-solid",
        "secondary-white": "bg-white text-green",
        dark: "bg-gray-900 text-white",
        white: "bg-white text-gray-900",
        gray: "bg-gray-400 text-gray-900"
      };

      // Size-based classes
      let sizeClasses = {
        small: "text-sm py-0.5 px-2 font-medium",
        medium: "text-base py-3 px-3 font-bold",
        large: "text-base py-4 px-8 font-bold",
      };

      // Disabled classes
      let disabledClasses = this.disabled ? "!bg-gray-900 !bg-opacity-25 !cursor-not-allowed" : "";

      // Combine the classes
      return [
        baseClasses,
        modeClasses[this.mode] || modeClasses.primary, // default to 'primary'
        sizeClasses[this.size] || sizeClasses.medium,  // default to 'medium'
        this.customClasses, // custom classes provided as a prop
        disabledClasses,
      ].join(" ");
    }
  },
  methods: {
    /**
     * Function to handle the click event and emit the click back to the parent if the button is not disabled
     * @param event Click event of the button
     */
    handleClick(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      }
    }
  }
};
</script>

<style scoped></style>
